<template>
  <v-container fluid style="padding: 0 !important">
    <v-row>
      <!-- Contact Info -->
      <v-col
        cols="12"
        md="3"
        class="pl-4 pr-2"
        style="border-right: 1px solid #cccccc"
      >
        <div class="mb-2 text-center">
          <span style="font-size: larger">{{ $t('contact_us') }}</span>
        </div>
        <div class="text-center" v-for="(item, index) in contacts" :key="index">
          <a :href="item.href" target="_blank" style="text-decoration: none">
            <v-img
              :src="item.img"
              max-width="100"
              max-height="100"
              contain
              style="margin: auto"
            ></v-img>
            <span :color="textColor || 'primary'" style="font-size: medium">{{
              item.label
            }}</span>
          </a>
        </div>
      </v-col>

      <!-- Form -->
      <v-col cols="12" md="9">
        <div class="text-center mb-2">
          <span style="font-size: larger">{{ $t('request_demo') }}</span>
        </div>

        <validation-observer ref="addChannelform" v-slot="{ invalid }">
          <form @submit.prevent="submitForm">
            <v-row dense>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.first_name')"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.first_name"
                    :label="$t('form.field.first_name') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.last_name')"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.last_name"
                    :label="$t('form.field.last_name') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.telephone_no')"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.telephone_no"
                    :label="$t('form.field.telephone_no') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    maxlength="12"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.email')"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="form.email"
                    :label="$t('form.field.email') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    type="email"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.social_name')"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.social_name"
                    :label="$t('form.field.social_name') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('form.field.company_page')"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.company_page"
                    :label="$t('form.field.company_page') + ' *'"
                    :color="textColor"
                    dense
                    outlined
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.contact_topic"
                  :label="$t('form.field.contact_topic')"
                  :color="textColor"
                  dense
                  outlined
                />
              </v-col>
            </v-row>

            <!-- Submit button -->
            <div class="text-center mb-5">
              <v-btn
                :loading="loading"
                :disabled="invalid"
                type="submit"
                class="btn-custom w45"
              >
                {{ $t('send') }}
              </v-btn>
            </div>
          </form>
        </validation-observer>

        <v-divider></v-divider>

        <!-- Company Info -->
        <div class="text-center mt-5" style="line-height: 1.25rem">
          <span variant="h4">{{ $t('contact_address') }}</span>
          <div class="text-left mt-4">
            <span style="font-size: large">{{ $t('company_name') }}</span>
            <br />
            <span style="font-size: medium">{{ $t('zwiz_address') }}</span>
          </div>
          <div class="text-left mt-4">
            <span style="font-size: medium"
              >{{ $t('registrationNo') }}&nbsp;</span
            >
            <br />
            <a
              href="https://www.trustmarkthai.com/callbackData/popup.php?data=520-35-5-041d1dd7438a02908f85099cbb92b26757074adfa0&markID=firstmark"
              target="_blank"
              style="font-size: medium; color: var(--v-primary-text)"
            >
              0105560189633
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      loading: false,
      textColor: 'primary',
      form: {
        first_name: '',
        last_name: '',
        telephone_no: '',
        email: '',
        social_name: '',
        company_page: '',
        contact_topic: ''
      },
      contacts: [
        {
          label: 'Tel. (+66)2-821-5535',
          img: '/img/contactUs/call.svg',
          href: 'tel:+6628215535'
        },
        {
          label: 'sales@zwiz.ai',
          img: '/img/contactUs/mail.svg',
          href: 'mailto:sales@zwiz.ai'
        },
        {
          label: '@796yuafn',
          img: '/img/contactUs/line.svg',
          href: 'https://lin.ee/soXR6x3F'
        }
      ]
    }
  },
  mounted() {
    this.form.first_name = this.value.member_account.first_name
    this.form.last_name = this.value.member_account.last_name
    this.form.telephone_no = this.value.member_account.telephone_no
    this.form.email = this.value.email
  },
  methods: {
    async submitForm() {
      this.loading = true
      var formattedForm = {
        firstName: this.form.first_name,
        lastName: this.form.last_name,
        telephoneNo: this.form.telephone_no,
        email: this.form.email,
        socialName: this.form.social_name,
        pageName: this.form.company_page,
        contactTopic: this.form.contact_topic,
        ssoId: this.value.id,
        ssoEmail: this.value.email
      }
      var res = await this.$store.dispatch('ssoAccount/postLead', formattedForm)
      if (res) {
        this.$emit('closeDialog')
      }
      this.loading = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
